import * as types from '../types/userTypes';

const userLoginReducer = (
  state = { loading: false, token: {}, userInfo: {}, error: null },
  action
) => {
  switch (action.type) {
    case types.USER_LOGIN_REQUEST:
      return { ...state, loading: true };

    case types.USER_LOGIN_SUCCESS:
      return { ...state, loading: false, token: action.payload };
    case types.STORE_DECODED_USER_INFO:
      return { ...state, loading: false, userInfo: action.payload };
    case types.USER_LOGIN_FAILED:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default userLoginReducer;
